<template lang="pug">
#sub-empresa-blocoInserir-dados-contrato-upload-planilha
    h1 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.titulo') }}
    el-card
        .box-card-inserir-dados-planilha
            .box-card-inserir-dados-planilha__conteudo
                .box-card-inserir-dados-planilha__conteudo__bloco
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.texto') }}
                        <br> {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.textoQuebralinha')}}

                .box-card-inserir-dados-planilha__conteudo__bloco
                    .box-card-inserir-dados-planilha__conteudo__bloco__lista
                        ul
                            li.obrigatorio {{ this.usuarioLogado.ambienteLogado === 'PY' ? 'RUC' : 'CAR' }}
                            li.obrigatorio {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.volume') }}
                            li.obrigatorio(v-if='!isRastreabilidadeOffline') {{ $t(this.usuarioLogado.ambienteLogado === 'PY' ? 'Finca o Padrón' : 'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento') }}
                            li(v-else) {{ $t(this.usuarioLogado.ambienteLogado === 'PY' ? 'Finca o Padrón' : 'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento') }}

                    .box-card-inserir-dados-planilha__conteudo__bloco__upload
                        .box-card-inserir-dados-planilha__conteudo__bloco__buttons
                            span.btn-download(
                                @click='downloadPlanilhaExemplo()'
                            )
                                i.mdi.mdi-download
                                span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.modeloPlanilha') }}

                            el-upload.upload-demo(
                                action='#',
                                :auto-upload='false',
                                :show-file-list='false',
                                :on-change='enviarPlanilha',
                                :on-exceed='onExceed',
                                :limit='1',
                                ref='uploadPlanilhaTerritorio'
                            )
                                span
                                    el-button(
                                        :icon='loadingUpload ? "el-icon-loading" : "el-icon-upload2"',
                                        type='primary'
                                    ) {{ loadingUpload ? '' : this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.inserirPlanilha') }}

                            span
                                el-button(
                                    v-if='analiseElegibilidadeEmMassaAndamento',
                                    @click='abrirModalComAnalisesProntas',
                                    :icon='loadingAnaliseElegibilidade ? "el-icon-loading" : "el-icon-check"',
                                    :disabled='loadingAnaliseElegibilidade',
                                    type='primary'
                                ) {{ loadingAnaliseElegibilidade ? this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.emProcessamento') : this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.processamentoConcluido') }}

                div(v-if='analiseElegibilidadeEmMassaFinalizada')
                    hr
                    .bloco-inserir-contrato-originacao-planilha-lote-importada
                        .bloco-inserir-contrato-originacao-planilha-lote-importada__header
                            el-checkbox(
                                v-model='selecionarTodosItensEmMassa',
                                @change='handleSelecionarTodosItensEmMassa'
                            ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.selecionarTodos') }}

                            .select-alinhar-dados-lote
                                span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.visualizarAnálise') }}
                                el-select(
                                    v-model='selecionadoOpcoesVisualizarElegibilidade',
                                    multiple,
                                    collapse-tags,
                                    placeholder='Todos'
                                )
                                    el-option(
                                        v-for='item in opcoesVisualizarElegibilidade',
                                        :key='item.value',
                                        :label='item.label',
                                        :value='item.value'
                                    )

                        .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo
                            .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item(
                                v-for='(item, i) in listaLoteElegibilidade',
                                :key='i'
                            )
                                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda
                                    .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__cima
                                        el-checkbox(
                                            v-model='item.remover',
                                            :label='item.car',
                                            :key='i',
                                            @change='handleSelecionarItens'
                                        ) CAR: {{ item.car }}

                                        .analise-elegibilidade-span
                                            span.strong-elegibilidade {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.analiseElegibilidade') }}
                                            .analise-elegibilidade-span__resultado
                                                i.flow.flow-warning-sign(
                                                    :class='corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].classeCor : ""'
                                                )
                                                span(
                                                    :class='corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].classeCor : ""'
                                                ) {{ corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].status : '' }}

                                    .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__baixo
                                        .resultado(
                                            :class='corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].bloco : ""'
                                        )
                                            .resultado-diagnostico
                                                span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.diagnosticoSocioAmbiental') }}
                                                |
                                                span(
                                                    :class='statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade] ? statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade].corClasse : ""'
                                                ) {{ statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade] ? statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade].status : '' }}

                                            .resultado-saldo
                                                span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.saldoDisponivel') }}
                                                |
                                                span(
                                                    :class='item.saldo.saldoCar.saldoCARcapacidadeProdutiva <= 0 ? "status-danger" : "status-sucess"'
                                                ) {{ item.saldo.saldoCar.saldoCARcapacidadeProdutiva }} ({{ item.saldo.saldoCar.calculoSaca.saldoCARcapacidadeProdutivaSaca }} sc)

                                            .resultado-distancia
                                                span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.distancia') }}
                                                |
                                                span(
                                                    :class='getClassDistancia(item)'
                                                ) {{ item.municipioContrato.distancia }} km

                                            .resultado__link-detalhar.strong-elegibilidade
                                                span(
                                                    @click='verDetalhesElegibilidade(item)'
                                                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.verDetalhes') }}
                                                i.mdi.mdi-arrow-right

                                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__direita
                                    el-form(@submit.native.prevent)
                                        el-form-item(label='Volume (t)')
                                            el-input(
                                                v-model.prevent='item.volume',
                                                @blur='volumeRecebidoFormatado(i)'
                                            )

                            .listagem-vazia(
                                v-if='!listaLoteElegibilidade.length && dadosElegibilidadePlanilha.length'
                            )
                                p {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.semDadosFiltro') }}

                        .bloco-inserir-contrato-originacao-planilha-lote-importada__footer
                            .remover-item-lista(
                                @click='removerListaAnaliseElegibilidade'
                            )
                                i.el-icon-delete
                                | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.removerItem') }}
                            .volume-total-lista
                                span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeTotal') }}
                                    |
                                    |
                                    b {{ formatarTonelada(somaVolumeElegibilidade) }}
                            el-button(
                                type='primary',
                                @click='adicionarListaCar',
                                :loading='loadingProcessamentoPlanilha',
                                :icon='loadingProcessamentoPlanilha ? "el-icon-loading" : "el-icon-plus"'
                            ) {{ loadingProcessamentoPlanilha ? '' : this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.adicionarLista') }}

    ModalHeaderRastreabilidadeEmMassaPlanilha(
        :show='modalHeaderPlanilha',
        :dados='dadosHeader',
        @processarVinculo='processarVinculo',
        @voltar='modalHeaderPlanilha = false',
        :carregando='loadingProcessamentoPlanilha',
        :isRastreabilidadeOffline='this.isRastreabilidadeOffline'
    )

    ModalProcessamentoRastreabilidadeEmMassaPlanilha(
        :show='modalProcessamentoPlanilha',
        :dados='dadosProcessamentoPlanilha',
        :temError='temErrorDadosProcessamento',
        @analisarImoveisBackground='analisarImoveisBackground',
        @voltar='modalProcessamentoPlanilha = false',
        :carregando='loadingProcessamentoPlanilha'
    )

    ModalAnaliseElegibilidadeDetalhes(
        :show='ativarModalAnaliseElegibilidadeDetalhes',
        :dados='dadosAnaliseElegibilidadeDetalhes',
        :raiosPermitidosPorEstado='raiosPermitidosPorEstado',
        @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidadeDetalhes = false'
    )
</template>

<script>
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import ModalHeaderRastreabilidadeEmMassaPlanilha from '@/components/contratosOriginacao/ModalHeaderRastreabilidadeEmMassaPlanilha.vue';
import ModalProcessamentoRastreabilidadeEmMassaPlanilha from '@/components/contratosOriginacao/ModalProcessamentoRastreabilidadeEmMassaPlanilha.vue';
import ModalAnaliseElegibilidadeDetalhes from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeDetalhes.vue';
import formatters from '@/utils/formatters';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'SubEmpresaBlocoInserirDadosContratoUploadPlanilha',
    components: {
        ModalHeaderRastreabilidadeEmMassaPlanilha,
        ModalProcessamentoRastreabilidadeEmMassaPlanilha,
        ModalAnaliseElegibilidadeDetalhes
    },

    mounted() {},

    props: {
        numeroContrato: {
            required: true,
            type: String
        },
        safraNome: {
            required: true,
            type: Number
        },
        volumeDisponivelContrato: {
            type: Number,
            required: true
        },
        raiosPermitidosPorEstado: {
            type: Array,
            required: true
        },
        dadosContratoOriginacao: {
            required: true,
            type: Object
        },
        isRastreabilidadeOffline: {
            required: true,
            type: Boolean
        }
    },

    data() {
        return {
            dadosHeader: [],
            dadosProcessamentoPlanilha: [],
            dadosElegibilidadePlanilha: [],
            informacoesContratoElegibilidadePlanilha: {},
            temErrorDadosProcessamento: false,
            modalHeaderPlanilha: false,
            modalProcessamentoPlanilha: false,
            loadingProcessamentoPlanilha: false,
            loadingUpload: false,
            loadingAnaliseElegibilidade: false,
            analiseElegibilidadeEmMassaAndamento: false,
            analiseElegibilidadeEmMassaFinalizada: false,
            selecionarTodosItensEmMassa: false,
            limiteRaio: 200,
            somaVolumeElegibilidade: 0,
            ativarModalAnaliseElegibilidadeDetalhes: false,
            dadosAnaliseElegibilidadeDetalhes: {
                elegibilidade: '',
                safraNome: '',
                cpfCnpj: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null,
                    distanciaPermitida: null
                },
                dadosRestricaoEstado: {
                    possuiRestricaoEstado: null,
                    siglaEstadoCar: null,
                    siglaEstadoPermitido: null,
                    aplicarTodoEstado: null
                },
                dadosRestricaoMunicipio: {
                    possuiRestricaoMunicipio: null,
                    municipioCar: null,
                    municipioPermitido: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            },
            inputVolumeElegibilidade: '',
            planilha: null,
            corStatus: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: 'Elegível',
                    bloco: 'status-bloco-verde'
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: 'Inelegível',
                    bloco: 'status-bloco-vermelho'
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: '',
                    bloco: 'status-bloco-cinza'
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: 'Com alerta',
                    bloco: 'status-bloco-laranja'
                }
            },
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: 'Conforme'
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                }
            },
            selecionadoOpcoesVisualizarElegibilidade: [],
            opcoesVisualizarElegibilidade: [
                {
                    value: 'ELEGIVEL',
                    label: 'Elegível'
                },
                {
                    value: 'ALERTA',
                    label: 'Com alerta'
                },
                {
                    value: 'INELEGIVEL',
                    label: 'Inelegível'
                }
            ]
        };
    },
    beforeDestroy() {
        disconnect();
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        listaLoteElegibilidade() {
            if (!this.selecionadoOpcoesVisualizarElegibilidade.length) {
                return this.dadosElegibilidadePlanilha;
            } else {
                return this.dadosElegibilidadePlanilha.filter(item =>
                    this.selecionadoOpcoesVisualizarElegibilidade.includes(
                        item.analiseElegibilidade
                    )
                );
            }
        }
    },
    methods: {
        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.permitidoUmArquivoVez'
                ),
                position: 'top-left'
            });
        },

        async enviarPlanilha(planilha) {
            if (this.loadingUpload || this.modalHeaderPlanilha) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.processamentoEmAndamento'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }
            if (this.dadosElegibilidadePlanilha.length) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.concluaExcluiPlanilha'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.tamanhoArquivo'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx') {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.apenasXLSX'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }
            this.planilha = planilha;
            this.loadingUpload = true;
            this.dadosHeader = [];
            try {
                this.$notify.success({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.arquivoEnviadoProcessamento'
                    )
                });
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscarHeaderPlanilhaUpload(
                        planilha
                    );
                this.dadosHeader = data.cabecalho;
                this.modalHeaderPlanilha = true;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroUpload'
                    )
                });
            }
            this.$refs.uploadPlanilhaTerritorio.clearFiles();
            this.loadingUpload = false;
        },
        async processarVinculo(campos) {
            this.loadingProcessamentoPlanilha = true;
            try {
                let tipoContrato = this.dadosContratoOriginacao
                    .tipoContratoOffline
                    ? 'OFFLINE'
                    : 'ONLINE';
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.validarPlanilhaTerritorio(
                        campos,
                        this.planilha,
                        tipoContrato
                    );

                if (data.erros.length) {
                    this.temErrorDadosProcessamento = true;
                    this.dadosProcessamentoPlanilha = data.erros;
                } else {
                    this.temErrorDadosProcessamento = false;
                    this.dadosProcessamentoPlanilha = data.itens;
                }

                this.modalProcessamentoPlanilha = true;
                this.modalHeaderPlanilha = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroValidarPlanilha'
                    )
                });
            }
            this.loadingProcessamentoPlanilha = false;
        },
        resetarElegibilidade() {
            this.dadosElegibilidadePlanilha = [];
            this.informacoesContratoElegibilidadePlanilha = {};
            this.analiseElegibilidade = [];
            this.selecionarTodosItensEmMassa = false;
            this.selecionadoOpcoesVisualizarElegibilidade = [];
            this.loadingAnaliseElegibilidade = false;
            this.analiseElegibilidadeEmMassaAndamento = false;
            this.modalProcessamentoPlanilha = false;
            this.modalHeaderPlanilha = false;
            this.analiseElegibilidadeEmMassaFinalizada = false;
        },
        async analisarImoveis() {
            this.loadingProcessamentoPlanilha = true;
            this.resetarElegibilidade();
            try {
                const territorios = this.dadosProcessamentoPlanilha.map(
                    territorio => {
                        return {
                            numeroCar: territorio.CAR,
                            cpfCnpj: territorio['CPF/CNPJ'],
                            volume: territorio.Volume.replace(',', '.')
                        };
                    }
                );

                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.realizarElegibilidadeLote(
                        this.numeroContrato,
                        territorios
                    );
                if (!data.territorios.length) {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.dadosPlanilhaNaoEncontrados'
                        )
                    });
                } else {
                    data.territorios.forEach((item, index) => {
                        if (!item.hasOwnProperty('remover')) {
                            item.remover = false;
                        }
                        if (!item.hasOwnProperty('analiseElegibilidade')) {
                            item.analiseElegibilidade =
                                this.analisarElegibilidade(item);
                        }
                        this.dadosElegibilidadePlanilha.push(item);
                    });
                    this.calcularToneladaElegibilidade();
                }

                this.modalProcessamentoPlanilha = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroAnalisar'
                    )
                });
            }
            this.loadingProcessamentoPlanilha = false;
        },
        analisarImoveisBackground() {
            this.loadingProcessamentoPlanilha = true;
            this.conectarCanalNotificacaoProcessamento();
            this.resetarElegibilidade();
            try {
                const territorios = this.dadosProcessamentoPlanilha.map(
                    territorio => {
                        return {
                            numeroCar: territorio.CAR,
                            cpfCnpj: territorio['CPF/CNPJ'],
                            volume: territorio.Volume.replace(',', '.')
                        };
                    }
                );

                ContratoOriginacaoServiceSubEmpresa.realizarElegibilidadeLote(
                    this.numeroContrato,
                    territorios
                );

                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.territoriosEncaminhadosAnalise'
                    )
                });

                this.modalProcessamentoPlanilha = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroAnalise'
                    )
                });
            }
            this.loadingProcessamentoPlanilha = false;
            this.loadingAnaliseElegibilidade = true;
            this.analiseElegibilidadeEmMassaAndamento = true;
        },
        analisarElegibilidade(item) {
            if (
                item.diagnosticoSocioambiental
                    ?.resultadoDiagnosticoRastreabilidade === null
            ) {
                return;
            }

            if (item.municipioContrato?.distancia === null) {
                return;
            }
            if (item.saldo?.saldoCar?.saldoCARcapacidadeProdutiva === null) {
                return;
            }
            let resultadoElegibilidade = 'INDEFINIDO';
            if (
                item.diagnosticoSocioambiental
                    .resultadoDiagnosticoRastreabilidade === 'INCONFORME'
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            } else if (
                item.diagnosticoSocioambiental.nivelAlertaRastreabilidade ===
                'MEDIO_ALTO'
            ) {
                resultadoElegibilidade = 'ALERTA';
            } else {
                resultadoElegibilidade = 'ELEGIVEL';
            }

            if (!this.raioPermitido(item)) {
                resultadoElegibilidade = 'INELEGIVEL';
            }

            if (!this.satisfazRestricaoEstado(item)) {
                resultadoElegibilidade = 'INELEGIVEL';
            }

            // if (!this.satisfazRestricaoMunicipio(item)) {
            //     resultadoElegibilidade = 'INELEGIVEL';
            // }

            if (item.saldo.saldoCar?.saldoCARcapacidadeProdutiva <= 0) {
                resultadoElegibilidade = 'INELEGIVEL';
            }
            return resultadoElegibilidade;
        },
        abrirModalComAnalisesProntas() {
            this.analiseElegibilidadeEmMassaFinalizada = true;
        },
        verDetalhesElegibilidade(item) {
            this.resetModalAnaliseElegibilidadeDetalhes();
            this.dadosAnaliseElegibilidadeDetalhes.safraNome = this.safraNome;

            this.dadosAnaliseElegibilidadeDetalhes.dadosDiagnostico =
                item.diagnosticoSocioambiental;

            this.dadosAnaliseElegibilidadeDetalhes.dadosCalculoRaio.distanciaRaioMunicipioECar =
                item.municipioContrato.distancia;

            this.dadosAnaliseElegibilidadeDetalhes.dadosCalculoRaio.possuiIntersecao =
                item.municipioContrato.possuiIntersecaoCar;

            this.dadosAnaliseElegibilidadeDetalhes.dadosCalculoRaio.siglaEstadoContrato =
                item.municipioContrato.siglaEstadoContrato;

            this.dadosAnaliseElegibilidadeDetalhes.dadosCalculoRaio.distanciaPermitida =
                item.municipioContrato.distanciaPermitida;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoEstado.possuiRestricaoEstado =
                item.estadoContrato.possuiRestricaoEstado;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoEstado.siglaEstadoCar =
                item.estadoContrato.siglaEstadoCar;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoEstado.siglaEstadoPermitido =
                item.estadoContrato.siglaEstadoPermitido;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoEstado.aplicarTodoEstado =
                item.estadoContrato.aplicarTodoEstado;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoMunicipio.possuiRestricaoMunicipio =
                item.restricaoMunicipioContrato.possuiRestricaoMunicipio;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoMunicipio.municipioCar =
                item.restricaoMunicipioContrato.municipioCar;

            this.dadosAnaliseElegibilidadeDetalhes.dadosRestricaoMunicipio.municipioPermitido =
                item.restricaoMunicipioContrato.municipioPermitido;

            this.dadosAnaliseElegibilidadeDetalhes.dadosBuscaSaldo =
                item.saldo.saldoCar;

            this.dadosAnaliseElegibilidadeDetalhes.cpfCnpj =
                this.formatarCpfCnpj(item.cpfCnpj);

            this.dadosAnaliseElegibilidadeDetalhes.elegibilidade =
                item.analiseElegibilidade;

            this.ativarModalAnaliseElegibilidadeDetalhes = true;
        },
        formatarCpfCnpj(valor) {
            if (
                /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(valor) ||
                /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(valor)
            ) {
                return valor;
            } else {
                return formatters.numeralStringFormatTocpfCnpj(
                    valor.replace(/\D/g, '')
                );
            }
        },
        formatarTonelada(valor) {
            return formatters.formatNumber(valor, 2);
        },
        handleSelecionarTodosItensEmMassa() {
            let valor = true;
            if (this.selecionarTodosItensEmMassa) {
                valor = true;
            } else {
                valor = false;
            }
            this.selecionadoOpcoesVisualizarElegibilidade = [];
            this.dadosElegibilidadePlanilha.forEach(item => {
                item.remover = valor;
            });
        },
        removerListaAnaliseElegibilidade() {
            if (
                !this.dadosElegibilidadePlanilha.some(
                    item => item.remover === true
                )
            ) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.selecioneItemExcluir'
                    )
                });
                return;
            }
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.confirmarRemocao'
                        ),
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                        ),
                        {
                            confirmButtonText: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.sim'
                            ),
                            cancelButtonText: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.cancelar'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.dadosElegibilidadePlanilha =
                            this.dadosElegibilidadePlanilha.filter(item => {
                                return (
                                    !('remover' in item) ||
                                    item.remover === false
                                );
                            });
                        this.calcularToneladaElegibilidade();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.remocaoRealizada'
                            )
                        });
                    })
                    .catch(() => {});
            } catch (erro) {}
        },
        handleSelecionarItens() {
            if (
                this.dadosElegibilidadePlanilha.every(
                    item => item.remover === true
                )
            ) {
                this.selecionarTodosItensEmMassa = true;
            } else {
                this.selecionarTodosItensEmMassa = false;
            }
        },
        volumeRecebidoFormatado(index) {
            this.dadosElegibilidadePlanilha[index].volume =
                this.dadosElegibilidadePlanilha[index].volume.replace(
                    /,/g,
                    '.'
                );
            this.dadosElegibilidadePlanilha[index].volume =
                formatters.formatarTonelada(
                    this.dadosElegibilidadePlanilha[index].volume
                );
            this.calcularToneladaElegibilidade();
        },
        calcularToneladaElegibilidade() {
            this.somaVolumeElegibilidade = 0;
            if (this.dadosElegibilidadePlanilha.length) {
                this.dadosElegibilidadePlanilha.forEach(item => {
                    let valor = item['volume'];
                    if (typeof valor === 'string') {
                        valor = valor.replace(',', '.');
                    }
                    const numero = parseFloat(valor);
                    if (!isNaN(numero)) {
                        this.somaVolumeElegibilidade += numero;
                    }
                });
            }
        },
        adicionarListaCar() {
            if (this.loadingProcessamentoPlanilha) {
                return;
            }

            if (!this.dadosElegibilidadePlanilha.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inserirPlanilha'
                    )
                });
                return;
            }

            let comErroVolume = 0;
            let comErroRaio = 0;
            let comErroEstado = 0;
            let comErroSaldoCapacidadeProdutiva = 0;
            let volumeTotal = 0.0;
            let carsEmTela = [];

            this.dadosElegibilidadePlanilha.forEach(item => {
                carsEmTela.push(item.car);

                if (!item.volume) {
                    comErroVolume++;
                }

                if (!this.raioPermitido(item)) {
                    comErroRaio++;
                }

                if (!this.satisfazRestricaoEstado(item)) {
                    comErroEstado++;
                }

                // if (!this.satisfazRestricaoMunicipio(item)) {
                //     comErroMunicipio++;
                // }

                if (
                    item.volume &&
                    item.volume >
                        item.saldo.saldoCar?.saldoCARcapacidadeProdutiva
                ) {
                    comErroSaldoCapacidadeProdutiva++;
                }

                volumeTotal += parseFloat(item.volume);
            });

            if (comErroVolume > 0) {
                this.$notify.error({
                    message:
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ha'
                        ) +
                        `( ${comErroVolume} )` +
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeNãoInserido'
                        )
                });
                return;
            }
            if (comErroRaio > 0) {
                this.$notify.error({
                    message:
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ha'
                        ) +
                        `( ${comErroRaio} )` +
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distanciaSuperiorPermitida'
                        )
                });
                return;
            }

            if (comErroEstado > 0) {
                this.$notify.error({
                    message:
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ha'
                        ) +
                        `( ${comErroEstado} )` +
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.territorioForaDoEstadoPermitido'
                        )
                });
                return;
            }

            // if (comErroMunicipio > 0) {
            //    this.$notify.error({
            //        message:
            //            this.$t(
            //                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ha'
            //            ) +
            //            `( ${comErroMunicipio} )` +
            //            this.$t(
            //                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.territorioForaDoMunicipioPermitido'
            //            )
            //    });
            //    return;
            // }

            if (comErroSaldoCapacidadeProdutiva > 0) {
                this.$notify.error({
                    message:
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ha'
                        ) +
                        `( ${comErroSaldoCapacidadeProdutiva} )` +
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeInseridoExcede'
                        )
                });
                return;
            }

            let volumeInserido = parseFloat(
                this.dadosContratoOriginacao.volumeAdicionado
            )?.toFixed(3);

            volumeInserido = parseFloat(volumeInserido);

            const resultadoSoma = volumeTotal + volumeInserido;

            const volumeLimite = parseFloat(resultadoSoma?.toFixed(3));

            if (
                volumeLimite >
                this.informacoesContratoElegibilidadePlanilha.volume?.toFixed(3)
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeExeceContrato'
                    )
                });
                return;
            }

            const listaCarEmTelaEInseridos = carsEmTela.concat(
                this.informacoesContratoElegibilidadePlanilha.listaCarsInseridos
            );

            const carRepetido = this.verificaSeExisteCarRepetido(
                listaCarEmTelaEInseridos
            );

            if (carRepetido) {
                this.$notify.error({
                    message:
                        `${carRepetido}` +
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.contratoJaCadastrado'
                        ),
                    styles: {
                        whiteSpace: 'pre-line'
                    }
                });
                return;
            }

            this.loadingProcessamentoPlanilha = true;
            try {
                const territorios = this.dadosElegibilidadePlanilha.map(
                    territorio => {
                        if (typeof territorio.volume === 'string') {
                            territorio.volume = parseFloat(
                                territorio.volume.replace(',', '.')
                            );
                        }
                        const itemListaLoteElegibilidade =
                            this.listaLoteElegibilidade.find(
                                item => item.car === territorio.car
                            );
                        const fonteDados =
                            itemListaLoteElegibilidade?.saldo.saldoCar
                                .fonteDados.id;
                        return {
                            numeroCar: territorio.car,
                            cpfCnpj: territorio.cpfCnpj,
                            volume: territorio.volume,
                            fonteDados
                        };
                    }
                );

                ContratoOriginacaoServiceSubEmpresa.rastreabilidadeInserirLote(
                    this.numeroContrato,
                    territorios
                );

                this.$notify.success({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticosProcessados'
                    )
                });

                this.$emit('atualizarTabela');
                this.resetarElegibilidade();
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message,
                    customClass: 'notificacao-rastreabilidade-em-massa'
                });
            }
            this.loadingProcessamentoPlanilha = false;
        },
        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            link.setAttribute(
                'download',
                'planilha-exemplo-rastreabilidade-em-massa'
            );
            link.href = this.$t(
                `mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.urlPlanilha${
                    this.usuarioLogado.ambienteLogado === 'PY' ? 'PY' : ''
                }`
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        resetModalAnaliseElegibilidadeDetalhes() {
            this.dadosAnaliseElegibilidadeDetalhes = {
                elegibilidade: '',
                safraNome: '',
                cpfCnpj: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null
                },
                dadosRestricaoEstado: {
                    possuiRestricaoEstado: null,
                    siglaEstadoCar: null,
                    siglaEstadoPermitido: null,
                    aplicarTodoEstado: null
                },
                dadosRestricaoMunicipio: {
                    possuiRestricaoMunicipio: null,
                    municipioCar: null,
                    municipioPermitido: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            };
        },
        raioPermitido(item) {
            if (
                item.estadoContrato?.possuiRestricaoEstado &&
                item.estadoContrato?.aplicarTodoEstado
            ) {
                return (
                    item.estadoContrato?.siglaEstadoCar ===
                    item.estadoContrato?.siglaEstadoPermitido
                );
            }
            if (!item.municipioContrato?.distancia) {
                return true;
            }
            return (
                item.municipioContrato.distancia <=
                item.municipioContrato.distanciaPermitida
            );
        },
        satisfazRestricaoEstado(item) {
            if (
                !item.estadoContrato.possuiRestricaoEstado ||
                item.estadoContrato.siglaEstadoCar ===
                    item.estadoContrato.siglaEstadoPermitido
            ) {
                return true;
            }
            return false;
        },
        satisfazRestricaoMunicipio(item) {
            if (
                !item.restricaoMunicipioContrato.possuiRestricaoMunicipio ||
                item.restricaoMunicipioContrato.municipioCar ===
                    item.restricaoMunicipioContrato.municipioPermitido
            ) {
                return true;
            }
            return false;
        },
        getClassDistancia(item) {
            return this.raioPermitido(item) ? 'status-sucess' : 'status-danger';
        },
        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.conectarVegaAPi'
                    )
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/lote/contrato-originacao-territorio/analise-elegibilidade`,
                    response => {
                        const data = JSON.parse(response);
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.processamentoAtualizado'
                            )
                        });

                        if (!data.territorios.length) {
                            this.$notify.success({
                                message: this.$t(
                                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.dadosPlanilha'
                                )
                            });
                        } else {
                            data.territorios.forEach((item, index) => {
                                if (!item.hasOwnProperty('remover')) {
                                    item.remover = false;
                                }
                                if (
                                    !item.hasOwnProperty('analiseElegibilidade')
                                ) {
                                    item.analiseElegibilidade =
                                        this.analisarElegibilidade(item);
                                }
                                this.dadosElegibilidadePlanilha.push(item);
                            });
                            this.informacoesContratoElegibilidadePlanilha =
                                data.contratoDados;
                            this.calcularToneladaElegibilidade();

                            this.analiseElegibilidadeEmMassaFinalizada = true;
                        }

                        this.loadingAnaliseElegibilidade = false;
                        this.analiseElegibilidadeEmMassaAndamento = true;
                        this.modalProcessamentoPlanilha = false;
                        this.$emit('atualizarTabela');
                        disconnect();
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.websocket'
                    )
                });
                disconnect();
            }
        },
        verificaSeExisteCarRepetido(listaCarsInseridos) {
            const seen = new Set();

            for (let i = 0; i < listaCarsInseridos.length; i++) {
                const currentValue = listaCarsInseridos[i];

                if (seen.has(currentValue)) {
                    return currentValue;
                } else {
                    seen.add(currentValue);
                }
            }

            return null;
        },
        removerTerritorioBlocoInserirContratoUploadPlanilha(
            territoriosSelecionadosParaExcluir
        ) {
            if (Array.isArray(territoriosSelecionadosParaExcluir)) {
                for (let territorio of territoriosSelecionadosParaExcluir) {
                    this.removerCarDadosExistentesContratoOriginacao(
                        territorio.resumoDiagnosticoTerritorio.imovel.codigo
                    );
                }
            } else {
                this.removerCarDadosExistentesContratoOriginacao(
                    territoriosSelecionadosParaExcluir
                );
            }
        },
        removerCarDadosExistentesContratoOriginacao(car) {
            if (
                this.informacoesContratoElegibilidadePlanilha.listaCarsInseridos
            ) {
                this.informacoesContratoElegibilidadePlanilha.listaCarsInseridos =
                    this.informacoesContratoElegibilidadePlanilha.listaCarsInseridos.filter(
                        item => item !== car
                    );
            }
        }
    }
};
</script>

<style lang="scss">
#sub-empresa-blocoInserir-dados-contrato-upload-planilha {
    width: 100%;

    h1,
    ul {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .lista {
        display: flex;
        flex-direction: row;
    }

    el-card {
        margin-top: 10px;
    }
    .box-card-inserir-dados-planilha__conteudo {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        gap: 15px;

        .box-card-inserir-dados-planilha__conteudo__bloco {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 15px;
            .box-card-inserir-dados-planilha__conteudo__bloco__upload {
                .el-button.el-button--primary {
                    min-width: 200px;
                }
            }
            .box-card-inserir-dados-planilha__conteudo__bloco__buttons {
                display: flex;
                gap: 15px;
                width: 100%;
                justify-content: flex-end;
                align-items: center;
                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;
                    font-size: 14px;
                    i {
                        font-size: 15px;
                    }
                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }

            .box-card-inserir-dados-planilha__conteudo__bloco__lista {
                ul {
                    margin-bottom: 15px;
                }
            }

            .obrigatorio::after {
                content: ' *';
                color: #f56c6c;
            }
        }
        .listagem-vazia {
            text-align: center;
            margin-top: 30px;
            color: #a4a4a5;
        }
    }
    .bloco-inserir-contrato-originacao-planilha-lote-importada__header {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        .select-alinhar-dados-lote {
            display: flex;
            justify-content: space-between;
            gap: 5px;
            align-items: center;
            border: 1px solid var(--primary);
            border-radius: 5px;
            padding: 0px 11px;
            font-size: 14px;
            input::placeholder {
                color: var(--primary) !important;
            }
            .el-input__inner {
                border: 0px solid var(--primary) !important;
                padding-left: 5px !important;
            }
            .el-select__caret {
                color: var(--primary);
            }
        }
    }
    .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo {
        overflow-y: auto;
        max-height: 500px;

        .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item {
            display: flex;
            justify-content: space-between;
            gap: 10px;
            margin-bottom: 18px;
            .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda {
                display: flex;
                width: 80%;
                flex-direction: column;
                padding-top: 10px;
                .strong-elegibilidade {
                    font-weight: bold;
                }
                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__cima {
                    display: flex;
                    justify-content: flex-start;
                    gap: 20px;
                    font-size: 14px;
                    width: 100%;
                }
                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__baixo {
                    width: 100%;
                    padding-top: 10px;
                    .resultado {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        gap: 8px;
                        padding: 5px;
                        border-radius: 6px;
                        font-size: 14px;
                        align-items: center;
                        min-height: 40px;
                        padding-left: 10px;
                        padding-right: 10px;

                        .resultado__link-detalhar {
                            color: #1989fa;
                            cursor: pointer;
                        }
                        .resultado__link-detalhar:hover {
                            text-decoration: underline;
                        }
                    }
                }

                .analise-elegibilidade-span {
                    display: flex;
                }
            }
            .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__direita {
                width: 20%;
            }
            .status-amarelo {
                font-weight: bold;
                color: #bfae19;
                font-size: 14px;
                margin-left: 4px;
            }

            .status-laranja {
                font-weight: bold;
                color: var(--warning);
                font-size: 14px;
                margin-left: 4px;
            }

            .status-danger {
                font-weight: bold;
                color: var(--danger);
                font-size: 14px;
                margin-left: 4px;
            }

            .status-sucess {
                font-weight: bold;
                color: var(--green);
                font-size: 14px;
                margin-left: 4px;
            }
            .status-bloco-verde {
                background-color: #3591381a;
            }
            .status-bloco-laranja {
                background-color: #f9935a1a;
            }
            .status-bloco-vermelho {
                background-color: #ec32321a;
            }
            .status-bloco-cinza {
                background-color: #e7e7e7;
            }
        }
    }
    .bloco-inserir-contrato-originacao-planilha-lote-importada__footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        margin-top: 40px;
        .remover-item-lista {
            color: #ec3232;
            cursor: pointer;
            i {
                margin-right: 5px;
            }
        }
        .remover-item-lista:hover {
            text-decoration: underline;
        }

        .el-button {
            min-width: 167px;
        }
    }
}
.notificacao-rastreabilidade-em-massa {
    width: 500px;
}
.notify-error {
    margin-right: 15%;
    width: 500px;
}
</style>
